import apiClient from '../client';

const BASE = '/admin/parents';

export type MobileAccountStatus = 'active' | 'inactive' | 'blocked';

export interface ParentAccount {
  phone_e164:   string;
  display_name: string | null;
  photo_url:    string | null;
  /** 'active' = normal | 'inactive' = parent self-deleted | 'blocked' = admin-disabled */
  status:       MobileAccountStatus;
  /** Non-null when parent has self-deleted the account */
  deleted_at:   string | null;
}

export const parentAccountsApi = {
  /** Get mobile-app account info for a parent (by their phone number). */
  getAccount: (phone: string) =>
    apiClient.get<{ data: ParentAccount }>(`${BASE}/${encodeURIComponent(phone)}/account`).then((r) => r.data.data),

  /** Admin: update parent profile picture. */
  updateParentPhoto: (phone: string, photo_url: string) =>
    apiClient
      .patch<{ data: ParentAccount }>(`${BASE}/${encodeURIComponent(phone)}/photo`, { photo_url })
      .then((r) => r.data.data),

  /** Admin: update student (child) photo stored in admissions.child_photo. */
  updateStudentPhoto: (admissionId: number, photo_url: string) =>
    apiClient
      .patch<{ data: { admission_id: number; photo_url: string } }>(
        `${BASE}/students/${admissionId}/photo`,
        { photo_url },
      )
      .then((r) => r.data.data),
};

